import React from "react";
import { Field, getIn, setIn } from "formik";
import { Autocomplete } from "../../native";

export default props => (
  <div>
    <Field
      name={props.name}
      render={({ field, form: { touched, errors, values, setValues } }) => {
        const error = errors[field.name] || getIn(errors, field.name);
        const isDirty = touched[field.name] || getIn(touched, field.name);
        const setValue = value => {
          if (field.name.includes(".")) {
            setValues(setIn(values, field.name, value));
          } else {
            setValues({
              ...values,
              [field.name]: value
            });
          }
        };

        return (
          <Autocomplete
            {...props}
            {...field}
            error={isDirty && error}
            onChange={e => {
              setValue(e.target.value);
            }}
            onSelect={value => {
              typeof value === "string" && setValue(value);
            }}
          />
        );
      }}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/Autocomplete/index.js